import { BlankState } from '@domain-group/suit-theme'

import BlankStateImageUrl from '../../assets/no-media-selection.svg'

const MediaSelectionBlankState = () => (
  <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BlankStateImageUrl}>
    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Title>
      You don&apos;t have any orders that support media selection
      {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Title>

    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Paragraph>
      To specify which images should be used on specific orders you’ll need to have pending orders in the campaign.
      You can create orders or start from a quote to add them to your campaign.
      Once you have orders that support artwork you can select the media.
      {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Paragraph>
  </BlankState>
)

export default MediaSelectionBlankState
